export const selectVideoId = ({eventDetails}) => eventDetails?.videoId;
export const selectEventType = ({eventDetails}) => eventDetails.eventType || '';
export const selectRsvpOff = ({eventDetails}) => eventDetails.rsvp_off;
export const selectIsInEditMode = ({eventDetails}) => eventDetails.inEditMode;
